"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVERYWHERE_CODE = 'XX';
exports.CLIENT_RENDERED_ROUTE_MATCHERS = ['marketplace', 'brand'];
exports.default = {
    CLIENT_RENDERED_ROUTE_MATCHERS: exports.CLIENT_RENDERED_ROUTE_MATCHERS,
    EVERYWHERE_CODE: exports.EVERYWHERE_CODE,
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/constants.js
// module id = 2c6S
// module chunks = 0 2 6 8 20